export default function(html) {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '');
}
